<template>
	<nav class="sidenav navbar navbar-light navbar-vertical fixed-left navbar-expand-xs" id="sidenav-main">
		<div class="scrollbar-inner">
			<!-- Brand -->
			<div class="sidenav-header d-flex align-items-center">
				<router-link class="navbar-brand" to="/home">
					<img src="assets/img/gca_logo.png"  alt="...">
				</router-link>
				<div class="ml-auto">
					<!-- Sidenav toggler -->
					<div class="sidenav-toggler sidenav-toggler-light d-none d-xl-block" data-action="sidenav-unpin" data-target="#sidenav-main">
						<div class="sidenav-toggler-inner">
							<i class="sidenav-toggler-line"></i>
							<i class="sidenav-toggler-line"></i>
							<i class="sidenav-toggler-line"></i>
						</div>
					</div>
				</div>
			</div>
			<div class="navbar-inner">
				<!-- Collapse -->
				<div class="collapse navbar-collapse" id="sidenav-collapse-main">
					<!-- Nav items -->
					<ul class="navbar-nav">


						<li class="nav-item">
							<router-link class="nav-link" to="/home">
								<i class=" fas fa-home"></i>
								<span class="nav-link-text">Página de inicio</span>
							</router-link>
						</li>

						<li class="nav-item">
							<router-link class="nav-link" to="/productos">
								<i class=" fas fa-store"></i>
								<span class="nav-link-text">Ir a la tienda</span>
							</router-link>
						</li>

						<li class="nav-item">
							<a class="nav-link" href="#navbar-dashboards" data-toggle="collapse" role="button" aria-expanded="true" aria-controls="navbar-dashboards">
								<i class="fa fa-language"></i>
								<span class="nav-link-text">Idioma</span>
							</a>
							<div class="collapse show" id="navbar-dashboards">
								<ul class="nav nav-sm flex-column">
									<li class="nav-item active">
										<a href="#" class="nav-link">Español</a>
									</li>
									<li class="nav-item">
										<a href="#" class="nav-link">Inglés</a>
									</li>
								</ul>
							</div>
						</li>


						<li class="nav-item">
							<router-link class="nav-link" to="/ebooks">
								<i class="ni ni-books"></i>
								<span class="nav-link-text">Libros digitales</span>
							</router-link>
						</li>

						<li class="nav-item">
							<a class="nav-link" href="#navbar-proyectos" data-toggle="collapse" role="button" aria-expanded="true" aria-controls="navbar-proyectos">
								<i class="ni ni-chart-pie-35"></i>
								<span class="nav-link-text">Proyecto integrador</span>
							</a>
							<div class="collapse show" id="navbar-proyectos">
								<ul class="nav nav-sm flex-column">
									<li class="nav-item" v-for="version in versiones" :key="version.id">
										<router-link :to="'/projects?version=' + version.id + '&name=' + version.nombre" class="nav-link">{{ version.nombre }}</router-link>
									</li>
								</ul>
							</div>
						</li>



						<li class="nav-item">
							<a class="nav-link" href="#navbar-reportes" data-toggle="collapse" role="button" aria-expanded="true" aria-controls="navbar-reportes">
								<i class="ni ni-chart-pie-35"></i>
								<span class="nav-link-text">Reportes</span>
							</a>
							<div class="collapse show" id="navbar-reportes">
								<ul class="nav nav-sm flex-column">
									<li class="nav-item">
										<router-link to="/reporte-avance" class="nav-link">Reporte de avance</router-link>
									</li>
								</ul>
							</div>
						</li>




						<li class="nav-item">
							<a class="nav-link" href="#navbar-gmetrix" data-toggle="collapse" role="button" aria-expanded="true" aria-controls="navbar-gmetrix">
								<i class="fa fa-language"></i>
								<span class="nav-link-text">Exámen de práctica</span>
							</a>
							<div class="collapse show" id="navbar-gmetrix">
								<ul class="nav nav-sm flex-column">
									<li class="nav-item">
										<a href="#" class="nav-link" @click="ingresar(3)">Ingresar a Gmetrix</a>
									</li>
									<li class="nav-item">
										<a href="#" class="nav-link" data-toggle="modal"  @click="setPlataforma(3)">Activar código de simulador</a>
									</li>
								</ul>
							</div>
						</li>


						<li class="nav-item">
							<a class="nav-link" href="#">
								<i class="ni ni-settings"></i>
								<span class="nav-link-text">Configuración</span>
							</a>
						</li>


					</ul>
					<!-- Divider -->
					<hr class="my-3">
					<!-- Heading -->
					<h6 class="navbar-heading p-0 text-muted"></h6>
					<!-- Navigation -->
					<ul class="navbar-nav mb-md-3">
						<li class="nav-item">
							<a class="nav-link" href="#" @click.prevent="setPlataforma(0)">
								<i class="ni ni-settings"></i>
								<span class="nav-link-text">Activar código</span>
							</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" href="#" data-toggle="modal" data-target="#modal-form-group">
								<i class="ni ni-settings"></i>
								<span class="nav-link-text">Vincularse a un grupo</span>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</nav>
</template>
<script>
	export default {
		name: 'NavigationComponent',
		data() {
			return {
				codigosUsuario: [],
				versiones: [],
			}
		},
		methods: {
			async ingresar(id_plataforma) {
				if(id_plataforma == 3){
					this.openLoading()
					await axios.post(apiKS + 'api/ingresagmetrix', null, { headers })
					.then( response => {
						Swal.close()
						if(response.data.status == true) {
							this.registraAcceso(13)
							window.open(response.data.message)
						}
						if(response.data.status == false) {
							Swal.fire({
					        	icon: 'error',
					        	title: 'Oops...',
					        	text: response.data.message,
					        })
						}
					})
					.catch( error => {
						this.catchError()
					})
				}
			},
			setPlataforma(id_plataforma) {
				if(id_plataforma == 0 || id_plataforma == 3)
					$("#modal-form").modal('show')
				Fire.$emit('setPlataforma', {id_plataforma})
			},
			async registraAcceso(id_producto) {
				await axios.post(apiKS + 'api/accesos', { id_producto}, { headers })
				.then( response => {
					
				})
				.catch( error => {
					this.catchError()
				})
			},
			async setGroup() {

			}
		},
		mounted() {
			Fire.$on('asignaCodigosUsuario', (data) => {
				this.codigosUsuario = data
				data.forEach(codigo => {
					codigo.codigo.productos.forEach( producto => {
						if(producto.id != 16) {
							producto.versiones.forEach( version => {
								if(version.accesa_proyecto_integrador == 1 && version.proyecto_integrador == 1)
									this.versiones.push(version)
							} )
						}
						if(producto.id == 16) {
							this.versiones = []
							producto.versiones.forEach( version => {
								if(version.accesa_proyecto_integrador == 1 && version.proyecto_integrador == 1)
									this.versiones.push(version)
							} )
						}
					} )
				});
			})
		},
		beforeCreate() {
            if(!user) {
                if(!headers) {
                    if(localStorage.tokenETCSistema) {
                        headers = {
                            'Content-Type': 'application/json',
                            Authorization: localStorage.tokenETCSistema
                        }
                    }
                }
            }
        }
	}
</script>